<template>
  <div class="dialogue-modal-mask">
    <div class="dialogue-modal-wrapper">
      <div class="dialogue-modal-container">
        <div class="dialog-overlay">
          <div class="dialog">
            <header class="dialogue-modal-header">
              <h3 v-if="!hideTitle">{{ title }}</h3>
            </header>
            <div class="dialog-msg">
              <p>{{ msg }}</p>
            </div>
            <div class="footer">
              <div class="footer-btns">
                <button
                  class="btn button button-danger doAction"
                  @click.prevent="confirmAction"
                >{{ confirmButtonText }}</button>
                <button
                  class="btn button button-default cancelAction"
                  @click.prevent="cancelAction"
                >{{ cancelButtonText }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, ref } from "vue";
const props = defineProps([
  "hideTitle",
  "title",
  "msg",
  "confirmButtonText",
  "cancelButtonText",
]);
const emit = defineEmits([
  "confirm",
  "cancel",
  "close",
]);
const modalOpen = ref<boolean>(false);

function confirmAction() {
  emit("confirm");
}

function cancelAction() {
  modalOpen.value = false;
  emit("cancel");
}
</script>
<style scoped lang="scss">
.dialogue-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.dialogue-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.dialogue-modal-container {
  width: 76%;
  max-width: 800px;
  margin: 0px auto;
  padding: 0;
  background-color: #fff;
  border-radius: 0.6rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  max-height: 600px;
  text-align: center;
  color: red;
  padding-top: 10px;
}

.dialogue-modal-header {
  width: 100%;
  border-bottom: 0;
  padding: 0.5px;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  display: flex;
  justify-content: center;
}

.dialogue-modal .modal-title {
  margin-top: 1rem;
  padding: 1.563rem 1.5rem;
  width: 100%;
}

.dialogue-modal .close-btn {
  margin: 0 0 -1rem auto;
  padding: 1rem;
}

.dialogue-modal .close-btn img {
  height: 18px;
  width: 18px;
}


.dialog-ovelay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.50);
  z-index: 999999
}

.dialog-ovelay .dialog {
  width: 400px;
  margin: 100px auto 0;
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, .2);
  border-radius: 3px;
  overflow: hidden;
  padding: 10px 8px;
}

.dialog-ovelay .dialog header {
  padding: 10px 8px;
  background-color: #f6f7f9;
  border-bottom: 1px solid #e5e5e5
}

.dialog-ovelay .dialog header h3 {
  font-size: 14px;
  margin: 0;
  color: #555;
  display: inline-block
}

.dialog-ovelay .dialog header .fa-close {
  float: right;
  color: #c4c5c7;
  cursor: pointer;
  transition: all .5s ease;
  padding: 0 2px;
  border-radius: 1px
}

.dialog-ovelay .dialog header .fa-close:hover {
  color: #b9b9b9
}

.dialog-ovelay .dialog header .fa-close:active {
  box-shadow: 0 0 5px #673AB7;
  color: #a2a2a2
}

.dialog-ovelay .dialog .dialog-msg {
  padding: 12px 10px
}

.dialog-ovelay .dialog .dialog-msg p {
  margin: 0;
  font-size: 15px;
  color: #333
}

.dialog-ovelay .dialog footer {
  border-top: 1px solid #e5e5e5;
  padding: 8px 10px
}

.dialog-ovelay .dialog footer .controls {
  direction: rtl
}

.dialog-ovelay .dialog footer .controls .button {
  padding: 5px 15px;
  border-radius: 3px
}

// Footer
.footer-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 100%;
}

.footer-btns button:not(:first-child) {
  margin-left: 10px;
}

.button {
  cursor: pointer
}

.button-default {
  background-color: rgb(248, 248, 248);
  border: 1px solid rgba(204, 204, 204, 0.5);
  color: #5D5D5D;
}

.button-danger {
  background-color: #f44336;
  border: 1px solid #d32f2f;
  color: #f5f5f5
}

.link {
  padding: 5px 10px;
  cursor: pointer
}

// .confirmation-modal {
//   //   .footer-btns {
//   //   display: flex;
//   //     justify-content: center;
//   //     align-items: center;
//   // }
//   .confirmation-modal-body {
//     width: 100%;
//     min-height: 20%;
//     max-height: 100%;
//     overflow-y: hidden;
//     overflow-x: hidden;
//     margin-bottom: 2rem;
//     .content {
//       width: 85%;
//       height: fit-content;
//       margin: 0 auto;
//       padding-top: 10px;
//     }
//   }

//   .step-btns {
//     width: 85%;
//     margin: 0 auto;
//     text-align: center;
//   }
// }

// @media (max-width: 992px) {
//   .footer-btns {
//     .btn {
//       font-size: 1.1em;
//       max-width: calc(50% - 5px);
//       min-width: 140px;
//     }
//   }
// }</style>
